import { FieldMetadata, getInputProps } from '@conform-to/react'
import { Input } from '~/components/ui/input'
import { ComponentProps } from 'react'

interface InputConformProps {
    meta: FieldMetadata<string | number | File | File[]>
    type: Parameters<typeof getInputProps>[1]['type']
}

export const InputConform = ({
    meta,
    type,
    ...props
}: InputConformProps & ComponentProps<typeof Input>) => {
    return (
        <Input
            {...getInputProps(meta, { type, ariaAttributes: true })}
            {...props}
        />
    )
}
